import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl, RESIZED_WIDTH } from 'components/ResolveImage/utils';
import { DropzoneFile } from 'components/Dropzone/utils';

import './ListingCardThumbnail.styles.scss';

type ListingCardThumbnailProps = {
  className?: string;
  to?: string;
  gallery: DropzoneFile[];
  firmLogo?: string;
  isPremium?: boolean;
  shouldLazyLoad?: boolean;
};

const ListingCardThumbnail: React.FC<ListingCardThumbnailProps> = (props) => {
  const { className, to, gallery, firmLogo, isPremium, shouldLazyLoad } = props;

  const classes = classNames('listing-card-thumbnail', className);

  const content = (
    <>
      <ResolveImage
        src={getImgUrl(gallery?.[0]?.url, RESIZED_WIDTH[320])}
        alt="Listing gallery."
        shouldLazyLoad={shouldLazyLoad}
      />
      {isPremium && firmLogo && (
        <ResolveImage
          asCompanyLogo
          alt="Company logo."
          src={getImgUrl(firmLogo, RESIZED_WIDTH[240])}
          shouldLazyLoad={shouldLazyLoad}
        />
      )}
    </>
  );

  return to ? (
    <Link className={classes} to={to}>
      {content}
    </Link>
  ) : (
    <div className={classes}>{content}</div>
  );
};

export default ListingCardThumbnail;
